module.exports = __webpack_public_path__ + "static/media/chevron-right.4edb03b7.svg";